var cpuIcon = "https://shopfront-cdn.tekoapis.com/static/3d7140d43b672ba4.svg";

export { cpuIcon as default };
